export default "__VITE_ASSET__aVXzSpmS__"